import { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { NoData } from './NoData';
import { Button, IconButton, Typography } from '@mui/material';
import { confirmAlert } from 'react-confirm-alert';
import CloseIcon from '@mui/icons-material/Close';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 2,
};

// Компонент для отображения модального окна
export function BasicModal({ childClose, childOpen }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div id="modal">
      {childClose ? <div onClick={handleOpen}>{childClose}</div> : <NoData></NoData>}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {childOpen ? <>{childOpen}</> : <NoData></NoData>}
        </Box>
      </Modal>
    </div>
  );
}

// Компонент для отображения диалогового окна с кастомным UI
// Компонент для отображения диалогового окна с кастомным UI
function EDialog(options) {
  const doptions = {
    closeOnEscape: true,
    closeOnClickOutside: true, // Это должно быть true
    customUI: ({ onClose }) => {
      return (
        <div
          key="customCAUI"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.87)',
            zIndex: options.zIndex ? options.zIndex : 9999,
            width: '100%',
            height: '100%',
            position: 'fixed',
            // overflow: 'hidden',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
          onClick={() => {
            // Закрываем по клику на фоне (backdrop)
            if (options.closeOnClickOutside !== false) {
              onClose();
            }
          }}
        >
          <div
            key="customCAUIDiv"
            style={{
              backgroundColor: 'rgba(244, 244, 244, 1)',
              // border: '1px solid black',
              padding: 20,
              borderRadius: 15,
              overflow: 'hidden',
              width: 'max-content',
              height: options.height || 'auto',
              margin: '0 auto',
              marginTop: 100,
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '80vh',
            }}
            onClick={(e) => {
              // Останавливаем всплытие события, чтобы не закрывалось при клике внутри окна
              e.stopPropagation();
            }}
          >
            <div style={{ 
              width:'100%', 
              display:'flex', 
              justifyContent: 'space-between', 
              flexDirection: 'row', 
              borderBottom: '2px solid #d9d9d9', 
              marginBottom: '20px'
            }}>
              <Typography variant='h5'>{options?.title || ''}</Typography>
              <IconButton onClick={onClose}>
                <CloseIcon></CloseIcon>
              </IconButton>
            </div>
            <div style={{ overflow: 'auto', flex: 1 }}>
              {options.message}
            </div>
            
            {/* Добавляем кнопки если они есть в options */}
            {options.buttons && (
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                marginTop: '20px',
                paddingTop: '10px',
                borderTop: '1px solid #d9d9d9'
              }}>
                {options.buttons.map((button, index) => (
                  <Button
                    key={index}
                    variant={button.variant || 'contained'}
                    onClick={() => {
                      if (button.onClick) button.onClick();
                      onClose();
                    }}
                    sx={{
                      textTransform: 'none', 
                      fontWeight: 'bold', 
                      color: 'white',
                      backgroundColor:'#078376',
                      '&:hover': {
                        backgroundColor: '#045b52',
                      }
                    }}
                  >
                    {button.label}
                  </Button>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  confirmAlert(doptions);
}

export function ShowModal(title, message, onConfirm, zIndex = 9999, closeOnClickOutside=true) {
  // Создаем кнопки в зависимости от того, есть ли обработчик подтверждения
  const buttons = onConfirm ? [
    {
      label: 'ОК',
      onClick: onConfirm,
    },
    {
      label: 'Отмена',
      variant: 'outlined'
    },
  ] : [];

  EDialog({
    title,
    message,
    buttons,
    zIndex,
    closeOnClickOutside, // Разрешаем закрытие по клику вне окна
  });
}